<template>
  <div class="chart-shell">
    <Bar
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
    />
  </div>
</template>

<script>
import { Bar } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  name: "BarChart",
  components: {
    Bar,
  },
  props: {
    chartId: {
      type: String,
      default: "bar-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => ({}),
    },
    plugins: {
      type: Array,
      default: () => [],
    },
    labels: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "title",
    },
    datasets: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    maxValue() {
      return this.datasets.reduce((max, dataset) => {
        const values = Array.isArray(dataset.data) ? dataset.data : [];
        const datasetMax = values.reduce((innerMax, value) => {
          const numericValue = Number(value) || 0;
          return numericValue > innerMax ? numericValue : innerMax;
        }, 0);
        return datasetMax > max ? datasetMax : max;
      }, 0);
    },
    chartOptions() {
      const smallRange = this.maxValue <= 10;
      return {
        responsive: true,
        maintainAspectRatio: false,
        resizeDelay: 100,
        plugins: {
          legend: {
            position: "top",
            labels: {
              color: "#6b7280",
              boxWidth: 28,
              font: {
                size: 11,
              },
            },
          },
          tooltip: {
            displayColors: true,
          },
        },
        scales: {
          x: {
            grid: {
              color: "rgba(148, 163, 184, 0.10)",
              drawBorder: false,
            },
            ticks: {
              color: "#6b7280",
              autoSkip: true,
              maxRotation: 0,
              maxTicksLimit: 8,
              font: {
                size: 11,
              },
            },
          },
          y: {
            beginAtZero: true,
            suggestedMax: Math.max(1, this.maxValue),
            grid: {
              color: "rgba(148, 163, 184, 0.14)",
              drawBorder: false,
            },
            ticks: {
              color: "#6b7280",
              precision: 0,
              stepSize: smallRange ? 1 : undefined,
              font: {
                size: 11,
              },
            },
          },
        },
      };
    },
    chartData() {
      return {
        labels: this.labels,
        datasets: this.datasets,
      };
    },
  },
};
</script>

<style>
.chart-shell {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.chart-shell canvas {
  width: 100% !important;
  height: 100% !important;
}
</style>
